import { useTranslation } from "react-i18next";

import { withForm } from "../../../../../../hooks/use-form";
import { useGenderOptions } from "../../appointment-form/appointment-form.constant";
import { ADD_GUEST_FORM_FIELDS } from "./add-guest-form.constant";
import styles from "./add-guest-form.module.scss";

export const AddGuestForm = withForm({
  ...ADD_GUEST_FORM_FIELDS,
  render: ({ form }) => {
    const { t } = useTranslation();
    const GENDER_OPTIONS = useGenderOptions();

    return (
      <form
        className={styles.addGuestForm}
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className={styles.formWrapper}>
          <div className={styles.formRow}>
            {/* first name */}
            <form.AppField name="firstName">
              {field => <field.TextInputField placeholder={t("please-enter")} label={t("first-name")} />}
            </form.AppField>
            {/* last name */}
            <form.AppField name="lastName">
              {field => <field.TextInputField placeholder={t("please-enter")} label={t("last-name")} />}
            </form.AppField>
          </div>
          <div className={styles.formRow}>
            {/* email */}
            <form.AppField name="email">
              {field => <field.TextInputField placeholder={t("please-enter")} label={t("email")} />}
            </form.AppField>
          </div>
          <div className={styles.formRow}>
            {/* gender select */}
            <form.AppField name="gender">
              {(field) => {
                return (
                  <field.SelectInputField
                    placeholder={t("please-select")}
                    width="100%"
                    label={t("gender")}
                    options={GENDER_OPTIONS}
                  />
                );
              }}
            </form.AppField>
            <form.AppField name="phone">{field => <field.PhoneInputField label={t("phone")} width="100%" />}</form.AppField>
          </div>
        </div>
      </form>
    );
  },
});
